// -------------------------------------
//   SlickSlider
// -------------------------------------

jQuery(document).ready(function ($) {
    // Lazyload responsive images
    // $(document).on('init breakpoint', '#slick-banner', function(event){
    //     var slideSources = $('.slick-slide').find('source');
    //     $(slideSources).each(function () {
    //         $(this).attr('srcset', $(this).data('lazy'));
    //     });
    // });

    $('#slick-banner').slick({
        fade: false,
        arrows: true,
        dots: false,
        // lazyLoad: 'progressive',
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 5000,
    });

    // Centralizar título quando não houver setas
    $(document).on('init breakpoint', '#slick-equipe', function(event){
        if ($('#slick-equipe-arrows').is(':empty')) {
            $('.home-equipe-block .section-title').addClass('title-full');
        } else {
            $('.home-equipe-block .section-title').removeClass('title-full');
        }
    });

    $('#slick-equipe').slick({
        infinite: true,
        speed: 300,
        arrows: true,
        appendArrows: $("#slick-equipe-arrows"),
        dots: false,
        lazyLoad: 'progressive',
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        adaptiveHeight: true,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 839,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                }
            },
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });
});

//# sourceMappingURL=data:application/json;charset=utf8;base64,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
